import { getRemainingLimits } from '@retail/limits';
import { getLogoutUrl } from '@retail/auth';
import { findRetailTokenOrLogout } from '@retail/core';
import { fetchCountriesIfNeeded } from '@shared/info-api';
import { INSTANCE_NAMES, getInstance } from '@retail/single-instance-cache';
import { startCheckingForNewTransactions } from '@retail/transactions-products';
import {
    georgeStats,
    hasTrackedSingletonEvent,
    trackEvent2,
    trackSingletonEvent,
} from '@shared/statistics';
import { loadUserImage } from '@retail/profile';
import { logger } from '@luna/logger';
import { overrideApiTargetFromUrl } from '@shared/dev-tools-utils';
import { queryContactsIfNeeded } from '@shared/contact-data-management-utils';
import { isInWebView } from '@shared/george-go';
import { selectMyProfileData } from '@shared/profile';
import type { CardCollection } from '@retail/cards-core';
import { triggerGlobalEvent } from '@luna/events';

import { trackGlobalProperties } from './startup/trackGlobalProperties';
import { getLoadingTime, stopLoadingTimeTracking } from './LoadingTimeTracker';

export function initialLoad(): void {
    triggerGlobalEvent('startup:initialized');
    stopLoadingTimeTracking();
    georgeStats.trackEvent('loading', 'loading_done', { loadingTime: getLoadingTime() });
    trackGlobalProperties();
    startCheckingForNewTransactions();
}

function loadAfterDisplay(): void {
    getInstance<CardCollection>(INSTANCE_NAMES.LEGACY_CARD_COLLECTION).fetch();
    queryContactsIfNeeded();
    fetchCountriesIfNeeded();

    getRemainingLimits().fetch();

    const TRACK_EVENT_TIMEOUT = 8000;
    // Do it delayed so tracker is loaded
    setTimeout(() => {
        if (!hasTrackedSingletonEvent('sessionStarted') && !isInWebView()) {
            trackSingletonEvent('sessionStarted');
            trackEvent2('sessions', 'sessionStarted');
            trackEvent2('sessionLux', 'userLoggedIn', {
                eventType: 'call_application',
                eventKey: 'session_001',
            });
        }
    }, TRACK_EVENT_TIMEOUT);
}

export function loadAfterMainItems(): void {
    try {
        loadAfterDisplay();
        loadUserImage(selectMyProfileData()?.offlineKey as string);
    } catch (e) {
        logger.error('Failed to init additional dependencies', e);
    }
}

export function initStartupValues(): void {
    overrideApiTargetFromUrl();

    if (!findRetailTokenOrLogout()) {
        window.document.location.href = getLogoutUrl();
    }
}
